import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ArrowSplitProps = IconComponentBaseProps;

export const ArrowSplit = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: ArrowSplitProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7237_100279"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7237_100279)">
        <path
          d="M3.5 9C3.35833 9 3.23961 8.95206 3.14383 8.85617C3.04794 8.76028 3 8.6415 3 8.49983C3 8.35806 3.04794 8.23933 3.14383 8.14367C3.23961 8.04789 3.35833 8 3.5 8H7.71417C7.73972 8 7.76428 7.99572 7.78783 7.98717C7.81139 7.97861 7.83383 7.96367 7.85517 7.94233L11.2975 4.5H9.83333C9.69167 4.5 9.57289 4.45206 9.477 4.35617C9.38122 4.26028 9.33333 4.1415 9.33333 3.99983C9.33333 3.85806 9.38122 3.73933 9.477 3.64367C9.57289 3.54789 9.69167 3.5 9.83333 3.5H12.3973C12.5681 3.5 12.7112 3.55778 12.8267 3.67333C12.9422 3.78878 13 3.93189 13 4.10267V6.66667C13 6.80833 12.9521 6.92711 12.8562 7.023C12.7603 7.11878 12.6415 7.16667 12.4998 7.16667C12.3581 7.16667 12.2393 7.11878 12.1437 7.023C12.0479 6.92711 12 6.80833 12 6.66667V5.2025L8.55383 8.64867C8.44439 8.75811 8.316 8.844 8.16867 8.90633C8.02133 8.96878 7.86639 9 7.70383 9H3.5ZM9.83333 13.5C9.69167 13.5 9.57289 13.4521 9.477 13.3562C9.38122 13.2603 9.33333 13.1415 9.33333 12.9998C9.33333 12.8581 9.38122 12.7393 9.477 12.6437C9.57289 12.5479 9.69167 12.5 9.83333 12.5H11.2975L9.30767 10.5205C9.20856 10.4214 9.15794 10.3037 9.15583 10.1673C9.15361 10.031 9.20422 9.91111 9.30767 9.80767C9.41111 9.70422 9.53161 9.6525 9.66917 9.6525C9.80683 9.6525 9.92733 9.70422 10.0307 9.80767L12 11.7975V10.3333C12 10.1917 12.0479 10.0729 12.1438 9.977C12.2397 9.88122 12.3585 9.83333 12.5002 9.83333C12.6419 9.83333 12.7607 9.88122 12.8563 9.977C12.9521 10.0729 13 10.1917 13 10.3333V12.8973C13 13.0681 12.9422 13.2112 12.8267 13.3267C12.7112 13.4422 12.5681 13.5 12.3973 13.5H9.83333Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
